import api from './api';

// SOP服务
const sopService = {
  // 获取SOP模板列表
  getTemplates: async (params) => {
    console.log('获取SOP模板列表，参数:', params);
    
    try {
      const response = await api.get('/v1/sop/templates', { 
        params,
        headers: {
          'X-Tenant-ID': params.tenantId
        }
      });
      console.log('SOP模板列表响应:', response.data);
      return response.data;
    } catch (error) {
      console.error('获取SOP模板列表错误:', error);
      throw error;
    }
  },
  
  // 获取SOP模板详情
  getTemplateById: async (id, tenantId) => {
    console.log(`获取SOP模板详情，ID: ${id}`);
    
    try {
      const response = await api.get(`/v1/sop/templates/${id}`, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      console.log('SOP模板详情响应:', response.data);
      return response.data;
    } catch (error) {
      console.error(`获取SOP模板详情错误:`, error);
      throw error;
    }
  },
  
  // 创建SOP模板
  createTemplate: async (template, tenantId) => {
    console.log('创建SOP模板:', template);
    
    try {
      const response = await api.post('/v1/sop/templates', template, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      console.log('创建SOP模板响应:', response.data);
      return response.data;
    } catch (error) {
      console.error('创建SOP模板错误:', error);
      throw error;
    }
  },
  
  // 更新SOP模板
  updateTemplate: async (id, template, tenantId) => {
    console.log(`更新SOP模板 ID: ${id}`, template);
    
    try {
      const response = await api.put(`/v1/sop/templates/${id}`, template, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      console.log('更新SOP模板响应:', response.data);
      return response.data;
    } catch (error) {
      console.error('更新SOP模板错误:', error);
      throw error;
    }
  },
  
  // 检查模板编码是否唯一
  checkCodeUnique: async (code, excludeId, tenantId) => {
    console.log(`检查SOP模板编码唯一性: ${code}, 排除ID: ${excludeId}`);
    
    try {
      const response = await api.get('/v1/sop/templates/check-code', {
        params: {
          code,
          excludeId
        },
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      console.log('检查编码唯一性响应:', response.data);
      return response.data;
    } catch (error) {
      console.error('检查编码唯一性错误:', error);
      throw error;
    }
  },
  
  // 获取SOP管理详情
  getManagementDetail: async (id, tenantId) => {
    try {
      const response = await api.get(`/v1/sop/management/${id}`, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      console.log('获取SOP详情响应 (原始数据):', JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error('获取SOP模板详情失败:', error);
      throw error;
    }
  },
  
  // 创建SOP模板和步骤
  createSopWithSteps: async (requestData, tenantId) => {
    try {
      const result = await api.post('/v1/sop/management', requestData, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      return result.data;
    } catch (error) {
      console.error('创建SOP模板失败:', error);
      throw error;
    }
  },
  
  // 更新SOP模板和步骤
  updateSopWithSteps: async (id, requestData, tenantId) => {
    try {
      const result = await api.put(`/v1/sop/management/${id}`, requestData, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      return result.data;
    } catch (error) {
      console.error('更新SOP模板失败:', error);
      throw error;
    }
  },
  
  // 激活SOP模板
  activateTemplate: async (id, tenantId) => {
    try {
      const result = await api.put(`/v1/sop/management/${id}/activate`, {}, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      return result.data;
    } catch (error) {
      console.error('激活SOP模板失败:', error);
      throw error;
    }
  },
  
  // 禁用SOP模板
  deactivateTemplate: async (id, tenantId) => {
    try {
      const result = await api.put(`/v1/sop/management/${id}/deactivate`, {}, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      return result.data;
    } catch (error) {
      console.error('禁用SOP模板失败:', error);
      throw error;
    }
  },
  
  // 检查SOP模板是否有执行实例
  checkHasExecutions: async (id, tenantId) => {
    try {
      const result = await api.get(`/v1/sop/management/${id}/has-executions`, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      return result.data;
    } catch (error) {
      console.error('检查SOP执行实例失败:', error);
      throw error;
    }
  },
  
  // 复制SOP模板
  copySop: async (id, copyRequest, tenantId) => {
    console.log(`复制SOP模板 ID: ${id}`, copyRequest);
    
    try {
      const response = await api.post(`/v1/sop/management/${id}/copy`, copyRequest, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      console.log('复制SOP模板响应:', response.data);
      return response.data;
    } catch (error) {
      console.error('复制SOP模板错误:', error);
      throw error;
    }
  },
  
  // 删除SOP模板（包括所有步骤和触发规则）
  // 注意：此操作同时会取消该模板的所有执行中实例
  deleteTemplate: async (id, tenantId) => {
    console.log(`删除SOP模板 ID: ${id}`);
    
    try {
      const response = await api.delete(`/v1/sop/management/${id}`, {
        headers: {
          'X-Tenant-ID': tenantId
        }
      });
      console.log('删除SOP模板响应:', response.status);
      return true;
    } catch (error) {
      console.error('删除SOP模板错误:', error);
      throw error;
    }
  }
};

export default sopService; 